// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const IdeaIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path
        d="M21.46 13.65q.46-.62.38-1.37-.11-.77-.71-1.23l-3.46-2.62q-.3-.24-.3-.64l.25-4.36q.02-.64-.34-1.16c-.6-.83-1.74-1.02-2.56-.43L11.1 4.35c-.2.15-.46.18-.7.09L6.32 2.92h-.01q-.57-.2-1.12-.03-.74.2-1.13.88c-.24.43-.3.94-.17 1.42l1.23 4.18q.1.38-.14.7L2.22 13.5q-.4.5-.41 1.13c0 .49.17.96.52 1.3.34.36.8.56 1.29.57l4.36.05c.25.01.49.14.62.33l2.37 3.65c.22.34.56.6.93.72q.3.1.62.1.42 0 .8-.18.69-.35.94-1.06l1.47-4.14q.15-.37.53-.48l4.22-1.18q.6-.16.98-.66"
        opacity=".5"
      />
      <path d="m21.97 21.12-2.76-2.96c-.31-.33-.83-.35-1.16-.04-.33.3-.35.82-.04 1.15l2.76 2.97q.26.26.6.26.31 0 .56-.22c.33-.3.35-.83.04-1.16" />
    </g>
  </SvgIcon>
);

export default IdeaIcon;
